import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

const enabledSections = [
  ["applied_vendors", "Applied"],
  ["already_enabled_vendors", "Skipped - already enabled"],
];

const disabledSections = [
  ["disabled_vendors", "Disabled"],
  ["remaining_enabled_vendors", "Still enabled by another SurveyArmor scope"],
  ["already_disabled_vendors", "Skipped - already disabled"],
];

function SurveyArmorResultDialog({ result = null, onClose }) {
  const open = Boolean(result);
  const enabled = Boolean(result?.enabled);
  const sections = enabled ? enabledSections : disabledSections;
  const visibleSections = sections
    .map(([key, label]) => ({ key, label, vendors: result?.[key] || [] }))
    .filter((section) => section.vendors.length > 0);
  const scopeLabel = result?.scope === "country" ? "country link" : "project code";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontSize: "18px", pb: 1 }}>
        SurveyArmor Security {enabled ? "Enabled" : "Disabled"}
      </DialogTitle>
      <DialogContent dividers>
        <SoftTypography variant="body2" color="text" mb={1.5}>
          Result for this {scopeLabel}
        </SoftTypography>

        {visibleSections.map((section) => (
          <SoftBox key={section.key} mb={1.5}>
            <SoftTypography variant="button" fontWeight="bold" color="dark">
              {section.label} ({section.vendors.length})
            </SoftTypography>
            <SoftBox component="ul" mt={0.5} mb={0} pl={2.5}>
              {section.vendors.map((vendor) => (
                <SoftTypography
                  key={`${section.key}-${vendor}`}
                  component="li"
                  variant="caption"
                  color="text"
                >
                  {vendor}
                </SoftTypography>
              ))}
            </SoftBox>
          </SoftBox>
        ))}

        {!visibleSections.length && (
          <SoftTypography variant="body2" color="text">
            No vendor links currently exist in this scope. Future vendor links will inherit this
            setting.
          </SoftTypography>
        )}
      </DialogContent>
      <DialogActions>
        <SoftButton variant="gradient" color="info" size="small" onClick={onClose}>
          Close
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}

SurveyArmorResultDialog.propTypes = {
  result: PropTypes.shape({
    scope: PropTypes.oneOf(["country", "project"]),
    enabled: PropTypes.bool,
    applied_vendors: PropTypes.arrayOf(PropTypes.string),
    already_enabled_vendors: PropTypes.arrayOf(PropTypes.string),
    disabled_vendors: PropTypes.arrayOf(PropTypes.string),
    remaining_enabled_vendors: PropTypes.arrayOf(PropTypes.string),
    already_disabled_vendors: PropTypes.arrayOf(PropTypes.string),
  }),
  onClose: PropTypes.func.isRequired,
};

export default SurveyArmorResultDialog;
